import React from 'react';
import styled from 'styled-components';
import {
  cssColorValue,
  IconAlbum,
  semanticColors,
  spacer16,
  spacer48,
  Type,
} from '@spotify-internal/encore-web';
import { TypeWithMargin } from '@components/shared/styles';

export const StyledIconAlbum = styled(IconAlbum)`
  background: ${cssColorValue('essentialBrightAccent')};
  width: ${spacer48};
  height: ${spacer48};
  border-radius: 50%;
  padding: 10px;
  text-align: center;
  color: ${cssColorValue('backgroundBase')};
`;

const Container = styled.div`
  display: flex;
  background-color: ${cssColorValue(semanticColors.backgroundHighlight)};
  height: 350px;
  justify-content: center;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
  max-width: 350px;
`;

interface EmptyStateProps {
  title: string;
  subtitle: string;
}

export const EmptyState = ({ title, subtitle }: EmptyStateProps) => {
  return (
    <Container>
      <Content>
        <StyledIconAlbum iconSize={32} />
        <TypeWithMargin
          variant="celloCanon"
          semanticColor="textBase"
          marginBottom={spacer16}
          marginTop={spacer16}
        >
          {title}
        </TypeWithMargin>
        <Type variant="viola" semanticColor="textBase">
          {subtitle}
        </Type>
      </Content>
    </Container>
  );
};
